import React, { useState } from 'react';
import { confirmable, createConfirmation } from 'react-confirm';
import BasicButton from '../../../../components/BasicButton';
import BasicButtonGroup from '../../../../components/BasicButtonGroup';
import LazyLoadSelect from '../../../../components/LazyLoadSelect';
import LoadMask from '../../../../components/LoadMask';
import Popup from '../../../../components/Popup';
import UxHelpers from '../../../../helpers/ux-helpers';
import useApi from '../../../../hooks/useApi';
import Dialog from '../../index';

const AssignProcessDialog = props => {
  const {
    show,
    proceed,
    dismiss,
    id,
    type,
    endpoints: { firm: endpointFirm, assign: endpointAssign },
  } = props;

  const [firm, setFirm] = useState();
  const [isSending, setIsSending] = useState(false);
  const api = useApi();

  const dismissHandler = () => {
    dismiss();
    UxHelpers.overflowLock('unlock');
  };

  const onSuccess = () => {
    setIsSending(true);
    UxHelpers.overflowLock('unlock');

    api.post(
      endpointAssign,
      {
        id,
        FirmID: firm.value,
      },
      {
        handleError: response => proceed(response),
        handleSuccess: () => proceed(),
        handleComplete: () => setIsSending(false),
      }
    );
  };

  const getOptions = (query, offset) => {
    return new Promise(resolve =>
      api.get(
        endpointFirm,
        {
          query,
          offset,
        },
        {
          handleComplete: ({ data }) => resolve(data),
        }
      )
    );
  };

  const onChange = value => {
    setFirm(value);
  };

  const buttons = (
    <BasicButtonGroup
      groupStyles={{
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <BasicButton
        disabled={!firm}
        controlFunc={onSuccess}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText={'Ok'}
      />
      <BasicButton
        controlFunc={dismissHandler}
        btnWidth={200}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText={'Cancel'}
      />
    </BasicButtonGroup>
  );

  const body = (
    <Dialog>
      <div className="dialog__form">
        <h3 className="dialog__title">Assign {type} to firm</h3>
        <LazyLoadSelect
          value={firm}
          isValid={true}
          controlFunc={onChange}
          name="firm"
          getOption={getOptions}
          label="Select firm"
          required={true}
        />
      </div>
    </Dialog>
  );

  return (
    show &&
    (isSending ? (
      <LoadMask />
    ) : (
      <Popup
        actions={{
          dismiss,
        }}
        buttonsRender={buttons}
        bodyRender={body}
        popupStyles={{ overflow: 'initial' }}
        popupInnerStyles={{ overflow: 'initial' }}
      />
    ))
  );
};

export default createConfirmation(confirmable(AssignProcessDialog));
